module.exports = require("./fy.d.ts");